/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tab-header[_ngcontent-%COMP%]{margin-bottom:20px}.modal-body[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-bottom:20px;font-size:20px;font-weight:400}form.add-comment[_ngcontent-%COMP%]{padding:0}.button-container[_ngcontent-%COMP%]{text-align:right;margin-bottom:25px;margin-top:-20px}.pad-bottom-sm[_ngcontent-%COMP%]{padding-bottom:10px}"];
export { styles as styles };
